import React from "react";
import PropTypes from "prop-types";

const Invalid = (props) => {
  return (
    <div className="container server-error text-center">
      <strong>{props.message}</strong>
    </div>
  );
};
/* Define PropTypes for the Invalid component */
Invalid.propTypes = {
  message: PropTypes.string.isRequired,
};
export default Invalid;
